import { useEffect } from 'react'
import MixpanelTracker from '../services/track/mixpanel'

export function useTrackModalOpen(
  eventName: string,
  open: boolean,
  properties?: Record<string, any>,
) {
  useEffect(() => {
    if (open) {
      MixpanelTracker.track(eventName, properties)
    }
  }, [open])
}
